import { Observable } from 'rxjs'
import { MbBillingInformation } from '../../../models'

export abstract class MbCheckoutBillingFormAdapter {

  abstract load(cartID: string, userID: string): Observable<MbBillingInformation>

  abstract post(form: MbBillingInformation, cartID: string, userID: string): Observable<any>
}
